import axios from "axios";
import client from "./client";

import store from "@/store";

// Cancel Token Request Interceptor
client.interceptors.request.use(
	function (config) {
		//  Generate cancel token source
		const source = axios.CancelToken.source();

		if (source) {
			// Set cancel token on this request
			config.cancelToken = source.token;

			store.commit("reportRequests/addToken", source);
		}

		return config;
	},
	function (error) {
		return Promise.reject(error);
	}
);

export const charts = {
	fetch: async (source) => {
		const { data } = await client.post(source);
		return data;
	},
	apexdata: async (source) => {
		const response = await client.get(source);
		return response.data;
	}
};
